import React, { useCallback, useState } from 'react';
import ClinicSearch from '../ClinicSearch';
import { parseInput } from './parseInput';

const PRESETS = [
  {
    id: 'clear',
    name: 'Clear',
    description: 'Reset input to empty',
    text: '',
  },
  {
    id: 'clid7715-example',
    name: 'CLID7715 Example',
    description: 'Doctor services with bullet format (16 doctors)',
    text: `[
  {"doctor_name": "Dr. Sandeep Jain 牙醫", "service_provided": "* 剝牙及剝智慧齒 Wisdom Teeth Removal\\n* 美白牙齒 Teeth Whitening\\n* 假牙 Dentures\\n* 牙齒貼片 (陶瓷貼片) Dental Veneers\\n* 種牙/植牙療程 Dental Implants\\n* 牙冠(牙套)和牙橋 Dental Crowns & Bridges – CEREC\\n* 美容牙科 Cosmetic Dentistry\\n* 打鼻鼾與睡眠窒息症 Snoring and Sleep Apnoea\\n* 牙周病治療 Gum Disease Treatment\\n* BlancOne 美白牙齒療程 BlancOne Whitening"},
  {"doctor_name": "臧薇敏牙醫", "service_provided": "* 剝牙及剝智慧齒 Wisdom Teeth Removal\\n* 種牙/植牙療程 Dental Implants\\n* All-on-4全口種植牙 All-On-Four Dental Implants"},
  {"doctor_name": "李廸信牙醫", "service_provided": "* 剝牙及剝智慧齒 Wisdom Teeth Removal\\n* 種牙/植牙療程 Dental Implants\\n* All-on-4全口種植牙 All-On-Four Dental Implants"},
  {"doctor_name": "Dr. Duncan Scorgie 牙醫", "service_provided": "* 美白牙齒 Teeth Whitening\\n* 杜牙根 (根管治療) Root Canal Treatment\\n* 牙齒貼片 (陶瓷貼片) Dental Veneers\\n* 種牙/植牙療程 Dental Implants\\n* 牙冠(牙套)和牙橋 Dental Crowns & Bridges – CEREC\\n* 美容牙科 Cosmetic Dentistry\\n* BlancOne 美白牙齒療程 BlancOne Whitening"},
  {"doctor_name": "麥穎恒牙醫", "service_provided": "* 美白牙齒 Teeth Whitening\\n* 隱適美 Invisalign\\n* 牙齒貼片 (陶瓷貼片) Dental Veneers\\n* 牙冠(牙套)和牙橋 Dental Crowns & Bridges – CEREC\\n* BlancOne 美白牙齒療程 BlancOne Whitening"},
  {"doctor_name": "劉嘉儀牙醫", "service_provided": "* 美白牙齒 Teeth Whitening\\n* 兒童牙科 Kids Dentist\\n* 隱適美 Invisalign\\n* 假牙 Dentures\\n* 牙齒貼片 (陶瓷貼片) Dental Veneers\\n* 種牙/植牙療程 Dental Implants\\n* 牙冠(牙套)和牙橋 Dental Crowns & Bridges – CEREC\\n* BlancOne 美白牙齒療程 BlancOne Whitening"},
  {"doctor_name": "Dr. Chamila Panduwawala 牙醫", "service_provided": "* 美白牙齒 Teeth Whitening\\n* 隱適美 Invisalign\\n* 牙齒貼片 (陶瓷貼片) Dental Veneers\\n* 牙冠(牙套)和牙橋 Dental Crowns & Bridges – CEREC\\n* BlancOne 美白牙齒療程 BlancOne Whitening"},
  {"doctor_name": "Blanche Ma 牙齒衛生員", "service_provided": "* 洗牙 Teeth Cleaning"},
  {"doctor_name": "Kate Lam 牙齒衛生員", "service_provided": "* 洗牙 Teeth Cleaning"},
  {"doctor_name": "Leagh Oppers 牙齒衛生員", "service_provided": "* 洗牙 Teeth Cleaning"},
  {"doctor_name": "Monika Jain 牙齒衛生員", "service_provided": "* 洗牙 Teeth Cleaning"},
  {"doctor_name": "張文偉牙醫", "service_provided": "* 杜牙根 (根管治療) Root Canal Treatment"},
  {"doctor_name": "Dr. Selina Chhabra Rampal 牙醫", "service_provided": "* 兒童牙科 Kids Dentist"},
  {"doctor_name": "袁潔臻牙醫", "service_provided": "* 隱適美 Invisalign\\n* 箍牙及牙齒矯正 Braces Orthodontics (Orthodontist)"},
  {"doctor_name": "Dr. Constanza María Araya 牙醫", "service_provided": "* 牙冠(牙套)和牙橋 Dental Crowns & Bridges – CEREC"},
  {"doctor_name": "周惠惠牙醫", "service_provided": "* 牙周病治療 Gum Disease Treatment"}
]`,
  },
];

const Step1_Input = ({ onNext, loading, error, setError }) => {
  const [clinicId, setClinicId] = useState('');
  const [pasteText, setPasteText] = useState('');
  const [fileContent, setFileContent] = useState(null);
  const [parseError, setParseError] = useState('');

  const processText = useCallback((text) => {
    return parseInput(text);
  }, []);

  const handleFileChange = useCallback((e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const isJson = file.name.endsWith('.json') || file.type === 'application/json';
    const isCsv = file.name.endsWith('.csv') || file.type === 'text/csv';
    if (!isJson && !isCsv) {
      setError('Please upload a JSON or CSV file');
      return;
    }
    setError('');
    setParseError('');
    const reader = new FileReader();
    reader.onload = (ev) => {
      const items = processText(ev.target.result);
      if (!items || items.length === 0) {
        setParseError('No rows found. CSV/JSON needs doctor_name and service_provided columns.');
        setFileContent(null);
      } else {
        setFileContent(items);
        setPasteText('');
      }
    };
    reader.readAsText(file, 'UTF-8');
  }, [setError, processText]);

  const handlePasteChange = useCallback((e) => {
    const text = e.target.value;
    setPasteText(text);
    setParseError('');
    setFileContent(null);
    if (!text.trim()) return;
    const items = processText(text);
    if (!items || items.length === 0) {
      setParseError('No rows found. Paste CSV or JSON with doctor_name, service_provided.');
    } else {
      setFileContent(items);
    }
  }, [processText]);

  const handleRemove = useCallback(() => {
    setFileContent(null);
    setPasteText('');
    setParseError('');
    setError('');
  }, [setError]);

  const handleNext = useCallback(() => {
    if (!clinicId.trim()) {
      setError('Please select a clinic');
      return;
    }
    if (!fileContent || fileContent.length === 0) {
      setError('Please paste or upload valid JSON or CSV with doctor_name and service_provided');
      return;
    }
    setError('');
    onNext({ clinicId: clinicId.trim(), items: fileContent });
  }, [clinicId, fileContent, onNext, setError]);

  const itemsCount = fileContent?.length || 0;

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Step 1: Select Clinic & Input</h2>
        <p className="text-gray-600">
          Select clinic, then paste or upload CSV/JSON with doctor_name and service_provided.
        </p>
      </div>

      <ClinicSearch
        selectedClinicId={clinicId}
        onClinicSelect={setClinicId}
        error={error}
        setError={setError}
      />

      <div className="bg-gray-50 p-6 rounded-lg space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Paste JSON or CSV</label>
          <textarea
            value={pasteText}
            onChange={handlePasteChange}
            placeholder='CSV: doctor_name,service_provided or JSON: [{"doctor_name":"...","service_provided":"..."}]'
            className="w-full px-4 py-2 border border-gray-300 rounded-md font-mono text-sm h-32"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Or upload file</label>
          <input
            type="file"
            accept=".json,application/json,.csv,text/csv"
            onChange={handleFileChange}
            className="block w-full text-sm text-gray-600"
          />
        </div>
        {parseError && <p className="text-sm text-red-600">{parseError}</p>}
      </div>

      {fileContent && (
        <div className="flex items-center justify-between p-4 bg-white border border-green-200 rounded-lg">
          <span className="text-sm font-medium text-green-800">
            {itemsCount} row{itemsCount !== 1 ? 's' : ''} parsed
          </span>
          <button type="button" onClick={handleRemove} className="text-red-600 hover:text-red-700 text-sm">
            Clear
          </button>
        </div>
      )}

      <div className="bg-gray-50 p-6 rounded-lg">
        <label className="block text-sm font-medium text-gray-700 mb-3">Example templates</label>
        <p className="text-xs text-gray-500 mb-3">Click a block to paste into input.</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {PRESETS.map((preset) => (
            <button
              key={preset.id}
              type="button"
              onClick={() => {
                setPasteText(preset.text);
                const items = preset.text ? parseInput(preset.text) : null;
                setFileContent(items);
                setParseError('');
              }}
              className="text-left p-4 bg-white border border-gray-200 rounded-lg hover:border-blue-400 hover:bg-blue-50/50 transition-colors"
            >
              <div className="font-medium text-gray-900">{preset.name}</div>
              <div className="text-xs text-gray-600 mt-1">{preset.description}</div>
            </button>
          ))}
        </div>
      </div>

      {error && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 text-red-800">{error}</div>
      )}

      <div className="flex justify-end">
        <button
          onClick={handleNext}
          disabled={!clinicId.trim() || !fileContent || fileContent.length === 0 || loading}
          className="px-8 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed font-medium"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Step1_Input;
